import { useSessionAuth } from '@/context/Auth';
import { readOrder } from '@/infrastructure/api/order';
import { Order } from '@/infrastructure/domain/order';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

export const useReadOrder = (
  orderId?: string,
): UseQueryResult<Order, Error> => {
  const { token } = useSessionAuth();

  return useQuery({
    queryKey: ['orders', orderId],
    queryFn: () => readOrder(token!, orderId!),
    enabled: Boolean(orderId),
  });
};
